export default __webpack_public_path__ + "static/media/dashboard-new-folio-icon-light copy.226ee7d1.svg";